
import { Popover, Transition } from "@headlessui/react";
import { useEffect, useState, Fragment } from "react";
import ReactDOM from "react-dom";
import { NavLink, Link } from "react-router-dom";
import logo from "assets/img/logo-full.png";
import qr from "assets/img/qr.png";
import DotLoader from "react-spinners/DotLoader";

const solutions = [
	{
		name: "Inicio",
		description: "",
		href: "/",
	},
	{
		name: "Nosotros",
		description: "",
		href: "/nosotros",
	},
	{
		name: "Servicios",
		description: "",
		href: "/servicios",
	},
	// {
	// 	name: "Servicios",
	// 	description: "",
	// 	href: "/servicios",
	// },
	{
		name: "Voluntariado",
		description: "",
		href: "/voluntariado",
	},
	{
		name: "Blog",
		description: "",
		href: "/blog",
	},
	{
		name: "Contacto",
		description: "",
		href: "/contacto",
	},
];

function Navbar() {
	const [loading] = useState(true);
	const [isDonateModalOpen, setIsDonateModalOpen] = useState(false);

	useEffect(() => {
		const handleEscape = (event) => {
			if (event.key === "Escape") {
				setIsDonateModalOpen(false);
			}
		};

		if (isDonateModalOpen) {
			document.body.style.overflow = "hidden";
			window.addEventListener("keydown", handleEscape);
		}

		return () => {
			document.body.style.overflow = "";
			window.removeEventListener("keydown", handleEscape);
		};
	}, [isDonateModalOpen]);

	window.onscroll = function () {
		scrollFunction();
	};

	function scrollFunction() {
		if (document.getElementById("navbar")) {
			if (
				document.body.scrollTop > 50 ||
				document.documentElement.scrollTop > 50
			) {
				document.getElementById("navbar").classList.add("shadow-navbar", "backdrop-blur-md", "bg-white/40");
			} else {
				document.getElementById("navbar").classList.remove("shadow-navbar", "backdrop-blur-md", "bg-white/40");
			}
		}
	}

	const donateModal = isDonateModalOpen
		? ReactDOM.createPortal(
				<div
					className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 px-4"
					onClick={() => setIsDonateModalOpen(false)}
				>
					<div
						className="relative w-full max-w-md rounded-xl bg-white p-6 shadow-2xl"
						onClick={(event) => event.stopPropagation()}
					>
						<button
							type="button"
							onClick={() => setIsDonateModalOpen(false)}
							className="absolute right-4 top-4 text-2xl leading-none text-gray-600 hover:text-black"
							aria-label="Cerrar modal de donaciones"
						>
							&times;
						</button>
						<h3 className="text-xl font-semibold text-gray-900 text-center">
							Escanea para donar
						</h3>
						<p className="mt-2 text-sm text-center text-gray-600">
							Usa este c&oacute;digo QR para realizar tu donaci&oacute;n.
						</p>
						<img
							src={qr}
							alt="Código QR para donaciones"
							className="mx-auto mt-4 w-full max-w-xs rounded-lg"
						/>
					</div>
				</div>,
				document.body
		  )
		: null;

	return (
		<>
		<nav
			data-scroll
			data-scroll-id="hey"
			id="navbar"
			className="py-4 top-4 transition duration-100 ease-in-out z-40 fixed rounded-full w-11/12 max-w-6xl"
		>
			<div className="px-2 xl:px-4">
				<div className="-ml-4 -mt-2 hidden lg:flex flex-wrap items-center justify-between sm:flex-nowrap md:px-4 px-2">
					<Link to="/" className="ml-4 mt-2">
						<img
							src={
								logo
							}
							width={110}
							height={110}
							className=""
							alt="Fundación Arduvi"
						/>
					</Link>
					<div className="ml-4 mt-2 flex-shrink-0">
						<NavLink
							to="/"
							className="text-lg inline-flex font-semibold leading-6 text-gray-900 border-b-2 border-transparent hover:border-yellow-400 transition duration-300 ease-in-out mx-4"
						>
							Inicio
						</NavLink>
						<NavLink
							to="/nosotros"
							className="text-lg inline-flex font-semibold leading-6 text-gray-900 border-b-2 border-transparent hover:border-yellow-400 transition duration-300 ease-in-out mx-4"
						>
							Nosotros
						</NavLink>
						<NavLink
							to="/servicios"
							className="text-lg inline-flex font-semibold leading-6 text-gray-900 border-b-2 border-transparent hover:border-yellow-400 transition duration-300 ease-in-out mx-4"
						>
							Servicios
						</NavLink>
						<NavLink
							to="/voluntariado"
							className="text-lg inline-flex font-semibold leading-6 text-gray-900 border-b-2 border-transparent hover:border-yellow-400 transition duration-300 ease-in-out mx-4"
						>
							Voluntariado
						</NavLink>
						<NavLink
							to="/blog"
							className="text-lg inline-flex font-semibold leading-6 text-gray-900 border-b-2 border-transparent hover:border-yellow-400 transition duration-300 ease-in-out mx-4"
						>
							Blog
						</NavLink>
						<NavLink
							to="/contacto"
							className="text-lg inline-flex font-semibold leading-6 text-gray-900 border-b-2 border-transparent hover:border-yellow-400 transition duration-300 ease-in-out mx-4"
						>
							Contacto
						</NavLink>

						<button
							type="button"
							onClick={() => setIsDonateModalOpen(true)}
							className="inline-flex ml-6 items-center rounded-md border border-transparent bg-yellow-button px-6 py-1.5 text-base font-medium text-white shadow-sm hover:bg-blue-button transition duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-offset-2"
						>
							Donaciones
							<DotLoader
								className="ml-3 -mr-1 h-5 w-5"
								loading={loading}
								size={20}
								color="#f2f2f2"
							/>
						</button>
					</div>
				</div>
				<div className="-ml-4 -mt-2 lg:hidden flex flex-wrap items-center justify-between sm:flex-nowrap md:px-4 px-2">
					<Link to="/" className="ml-4 mt-3">
						<img
							src={
								logo
							}
							width={110}
							height={110}
							className=""
							alt="Fundación Arduvi"
						/>
					</Link>
					<div className="ml-4 mt-2 flex items-center gap-2 flex-shrink-0">
						<button
							type="button"
							onClick={() => setIsDonateModalOpen(true)}
							className="inline-flex items-center rounded-md border border-transparent bg-yellow-button px-4 py-1.5 text-sm font-medium text-white shadow-sm hover:bg-blue-button transition duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-offset-2"
						>
							Donaciones
							<DotLoader
								className="ml-2 -mr-1 h-4 w-4"
								loading={loading}
								size={14}
								color="#f2f2f2"
							/>
						</button>
						<Popover className="relative">
							{({ open }) => (
								<>
									<Popover.Button
										className={`
                                ${open ? "" : "text-opacity-90"}
                                focus:ring-none focus:outline-none`}
									>
										{open ? (
											<i className="bx bx-x text-4xl mt-1"></i>
										) : (
											<i className="bx bx-menu text-4xl mt-1"></i>
										)}
									</Popover.Button>

									<Transition
										as={Fragment}
										enter="transition ease-out duration-200"
										enterFrom="opacity-0 translate-y-1"
										enterTo="opacity-100 translate-y-0"
										leave="transition ease-in duration-150"
										leaveFrom="opacity-100 translate-y-0"
										leaveTo="opacity-0 translate-y-1"
									>
										<Popover.Panel className="absolute -left-32 z-10 mt-5 w-screen max-w-sm -translate-x-1/2 transform px-4 sm:px-0 lg:max-w-3xl">
											<div className="overflow-hidden rounded-lg shadow-lg ring-1 ring-black ring-opacity-5">
												<div className="relative grid gap-8 bg-white p-7 lg:grid-cols-2">
													{solutions.map((item) => (
														<Link
															key={item.name}
															to={item.href}
															className="-m-3 flex items-center rounded-lg p-2 transition duration-150 ease-in-out hover:bg-gray-50 focus:outline-none focus-visible:ring focus-visible:ring-yellow-400 focus-visible:ring-opacity-50"
														>
															<div className="ml-4">
																<p className="text-sm font-medium text-gray-900">
																	{item.name}
																</p>
																<p className="text-sm text-gray-500">
																	{item.description}
																</p>
															</div>
														</Link>
													))}
												</div>
											</div>
										</Popover.Panel>
									</Transition>
								</>
							)}
						</Popover>
					</div>
				</div>
			</div>

		</nav>
		{donateModal}
		</>
	);
}



export default Navbar;
